import type { ReactNode } from "react";
import styles from "./SectionTitle.module.css";

export type SectionTitleProps = {
  /** Identifiant du titre, cible de l'`aria-labelledby` de la section. */
  id: string;
  children: ReactNode;
  /** Une ou deux phrases sous le titre. */
  description?: ReactNode;
  /** Boutons alignés à droite du titre. */
  actions?: ReactNode;
};

/**
 * Titre d'une section de page, sous le `<h1>` de l'en-tête.
 *
 * Cinq écrans l'avaient chacun dans leur module, à des tailles différentes :
 * le même niveau de titre se lisait en petites capitales ici, en gros là.
 */
export function SectionTitle({ id, children, description, actions }: SectionTitleProps) {
  return (
    <div className={styles.entete}>
      <div className={styles.textes}>
        <h2 id={id} className={styles.titre}>
          {children}
        </h2>
        {description !== undefined && <p className={styles.description}>{description}</p>}
      </div>
      {actions !== undefined && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
